enum WebAppReducerActionTypeEnum {
  SET_PRESCRIBER_SELECTED = 'setPrescriberSelected',
  SET_COMPANY_SELECTED = 'setCompanySelected',
  SET_SITE_SELECTED = 'setSiteSelected',
}

export { WebAppReducerActionTypeEnum };
